export default __webpack_public_path__ + "assets/images/bab6aa347b480133e6d3477693bf9467.png";